import {SET_HIGHLIGHTED_ELEMENT_TAB, SET_SIDE_PANEL_CONTENT, SWITCH_GRID} from '../actions/grid';
import {GridReducerType, SidePanelContent} from '../actions/types/grid.types';

export interface GridReducerState {
    showGrid: boolean;
    sidePanelContent: SidePanelContent;
    highlightedElementTab: string | null;
}

export const preloadedState = {
    showGrid: false,
    sidePanelContent: SidePanelContent.ELEMENTS,
    highlightedElementTab: null,
};

export const gridReducer = (state: GridReducerState = preloadedState, action: GridReducerType): GridReducerState => {
    switch (action.type) {
        case SWITCH_GRID:
            return {...state, showGrid: !state.showGrid};
        case SET_SIDE_PANEL_CONTENT:
            return {...state, sidePanelContent: action.content};
        case SET_HIGHLIGHTED_ELEMENT_TAB:
            return {...state, highlightedElementTab: action.tab};
        default:
            return {...state};
    }
};
